import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { RateLimitContext } from '../rateLimitContext/RateLimitContext'

import { GenericError } from '@percent/workplace-giving/common/components/GenericError/GenericError'

const DEFAULT_RETRY_AFTER = 10000

export function RateLimitContextController({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation()
  const [rateLimitState, setRateLimitHitValue] = useState({
    rateLimitHit: false,
    retryAfter: DEFAULT_RETRY_AFTER
  })
  const setRateLimitHit = useCallback(({ retryAfter }: { retryAfter?: number }) => {
    setRateLimitHitValue({
      rateLimitHit: true,
      retryAfter: retryAfter || DEFAULT_RETRY_AFTER
    })
  }, [])

  useEffect(() => {
    if (rateLimitState.rateLimitHit) {
      setTimeout(() => {
        setRateLimitHitValue({
          rateLimitHit: false,
          retryAfter: DEFAULT_RETRY_AFTER
        })
      }, rateLimitState.retryAfter)
    }
  }, [rateLimitState.rateLimitHit, rateLimitState.retryAfter])

  const value = useMemo(
    () => ({
      rateLimitHit: rateLimitState.rateLimitHit,
      setRateLimitHit
    }),
    [rateLimitState.rateLimitHit, setRateLimitHit]
  )

  if (rateLimitState.rateLimitHit) {
    return (
      <GenericError
        title={t('workplace_giving.errors.rateLimitTitle')}
        description={t('workplace_giving.errors.rateLimitDescription')}
      />
    )
  }

  return <RateLimitContext.Provider value={value}>{children}</RateLimitContext.Provider>
}
